exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* PhysicianAndPracticeInfoForm Style Sheet */\n\n._1P2w4VPnHG_jwrdEklQ74e{\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 23px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    letter-spacing: 0.25px;\n    padding: 2rem 0rem;\n    color: #142A39;\n}\n\n._1740cRDPLNcFidQem4fWGU {\n    width: 100%;\n    border: 1px solid #142a396c;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 4px;\n    height: 40px;\n    padding: 10px;\n}\n\n._1mO8Z-gPNjaOLCjbVSSpsC{\n    padding-bottom: 2rem;\n}", ""]);

// exports
exports.locals = {
	"title": "_1P2w4VPnHG_jwrdEklQ74e",
	"testInput": "_1740cRDPLNcFidQem4fWGU",
	"pageContainer": "_1mO8Z-gPNjaOLCjbVSSpsC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/PhysicianAndPracticeInfoForm/PhysicianAndPracticeInfoForm.styles.module.css
// module id = 9761
// module chunks = 23